/**
 * DevPage
 * This is DevPage API contract
 *
 * OpenAPI spec version: 1.1.0
 * Contact: apiteam@swagger.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ArticleCategories } from '../model/articleCategories';
import { ArticleCategory } from '../model/articleCategory';
import { ErrorResponse } from '../model/errorResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ArticlesCategoryService {

    protected basePath = 'http://localhost:8090';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Add article categories to domain
     * 
     * @param domainId 
     * @param articleCategory Categories objects that needs to be added to the store
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addCategories(domainId: string, articleCategory: Array<ArticleCategory>, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public addCategories(domainId: string, articleCategory: Array<ArticleCategory>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public addCategories(domainId: string, articleCategory: Array<ArticleCategory>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public addCategories(domainId: string, articleCategory: Array<ArticleCategory>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling addCategories.');
        }
        if (articleCategory === null || articleCategory === undefined) {
            throw new Error('Required parameter articleCategory was null or undefined when calling addCategories.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/articles/categories`,
            articleCategory,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete article category 
     * 
     * @param domainId 
     * @param categoryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteCategory(domainId: string, categoryId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteCategory(domainId: string, categoryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteCategory(domainId: string, categoryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteCategory(domainId: string, categoryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling deleteCategory.');
        }
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling deleteCategory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/articles/categories/${encodeURIComponent(String(categoryId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get article categories
     * 
     * @param domainId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCategories(domainId: string, observe?: 'body', reportProgress?: boolean): Observable<ArticleCategories>;
    public getCategories(domainId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ArticleCategories>>;
    public getCategories(domainId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ArticleCategories>>;
    public getCategories(domainId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling getCategories.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ArticleCategories>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/articles/categories`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update article category 
     * 
     * @param domainId 
     * @param categoryId 
     * @param articleCategory Category object that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateCategory(domainId: string, categoryId: string, articleCategory: ArticleCategory, observe?: 'body', reportProgress?: boolean): Observable<ArticleCategory>;
    public updateCategory(domainId: string, categoryId: string, articleCategory: ArticleCategory, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ArticleCategory>>;
    public updateCategory(domainId: string, categoryId: string, articleCategory: ArticleCategory, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ArticleCategory>>;
    public updateCategory(domainId: string, categoryId: string, articleCategory: ArticleCategory, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (domainId === null || domainId === undefined) {
            throw new Error('Required parameter domainId was null or undefined when calling updateCategory.');
        }
        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling updateCategory.');
        }
        if (articleCategory === null || articleCategory === undefined) {
            throw new Error('Required parameter articleCategory was null or undefined when calling updateCategory.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ArticleCategory>(`${this.configuration.basePath}/domains/${encodeURIComponent(String(domainId))}/articles/categories/${encodeURIComponent(String(categoryId))}`,
            articleCategory,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
